package de.oevbs.kunde.kundenportal2.services.delivery

import de.oevbs.businesspartner.bpcrmservice2.partner.model.Dispatch
import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.authentication.PortalSessionMiddleware
import de.oevbs.kunde.kundenportal2.components.globalInitTracker
import de.oevbs.kunde.kundenportal2.components.globalSubmitTracker
import de.oevbs.kunde.kundenportal2.model.services.delivery.DeliveryClientDefinition
import de.oevbs.kunde.kundenportal2.model.services.inbox.DeliveryState
import de.oevbs.kunde.kundenportal2.util.tryCatchAndHandleErrors
import de.oevbs.sfa.communication.sfaServiceOrigin
import de.oevbs.sfa.communication.use
import dev.fritz2.core.RootStore
import dev.fritz2.core.storeOf
import io.ktor.client.*
import io.ktor.client.engine.js.*
import kotlinx.browser.window
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map

class DeliveryStore(job: Job) : RootStore<DeliveryState>(DeliveryState(), job) {

    private val deliveryClient = object : DeliveryClientDefinition(window.location.sfaServiceOrigin) {
        override val client: HttpClient = HttpClient(Js, config)
    }.use(PortalSessionMiddleware)

    private val initFailedStore = storeOf(false, Job())
    val initFailedFlow: Flow<Boolean> = initFailedStore.data

    val dispatch: Flow<String> =
        data.map { if (it.initial.currentOption == Dispatch.EMail) "Mail" else it.initial.currentOption.value }
    val crmMailAddress: Flow<String> = data.map { it.delivery.crmMailAddress }
    val step: Flow<GeneralProgressStep> = data.map { it.step }
    val unchanged: Flow<Boolean> = data.map { it.delivery == it.initial }

    val init = handle { state ->
        globalInitTracker.track {
            val initData = tryCatchAndHandleErrors("Laden des Versandwegs") {
                deliveryClient.init()
            }
            if (initData == null) {
                initFailedStore.update(true)
                return@track state
            }
            DeliveryState(
                delivery = initData,
                step = GeneralProgressStep.SUBMIT1,
                initial = initData
            )
        }
    }

    val changeDispatch = handle<Dispatch> { state, dispatch ->
        globalSubmitTracker.track {
            tryCatchAndHandleErrors("Ändern des Versandwegs") {
                deliveryClient.setDelivery(state.delivery.currentOption)
            }?.let {
                state.copy(
                    delivery = state.delivery.copy(currentOption = dispatch),
                    step = GeneralProgressStep.SUCCESS2
                )
            } ?: state
        }
    }
}